import styled from "styled-components";

import { IconButtonInverted } from "./IconButton";

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div<{
  gap?: number;
  justify?: string;
  align?: string;
}>`
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap ?? 0}px;
  justify-content: ${(props) => props.justify};
  align-items: ${(props) => props.align};
`;

export const Space = styled.div<{ gap?: number }>`
  height: ${(props) => (props.gap ? `${props.gap}px` : "8px")};
`;

export const Title = styled("div")<{ weight?: number }>`
  margin-bottom: 20px;
  font-weight: ${(props) => (props.weight ? `${props.weight}` : "400")};
`;

export const GoButton = styled(IconButtonInverted)<{
  width?: string;
  height?: string;
}>`
  width: ${(props) => (props.width ? props.width : "10cqh")};
  height: ${(props) => (props.height ? props.height : "10cqh")};
`;
